module.exports = __webpack_public_path__ + "media/images/flags/32/Argentina-421a26ddcce0902f9e2fdd0ec4765133.png";